export default __webpack_public_path__ + "static/media/phone.04dcc1af.png";